import ApiHelper from '@/utils/api-helper'
import API from '@/constants/api'

class LearnContentTypeService {
  static getLearnContentTypes(limit = 100, page = 1) {
    return ApiHelper.fetch(`${API.URL + API.LEARN_CONTENT_TYPE}?pageSize=${limit}&page=${page}`)
  }

  static getLearnContentType(id) {
    return ApiHelper.fetch(`${API.URL + API.LEARN_CONTENT_TYPE}/${id}`)
  }

  static addLearnContentType(learnContentType) {
    return ApiHelper.fetch(`${API.URL + API.LEARN_CONTENT_TYPE}`, {
      method: 'POST',
      body: JSON.stringify({
        learnContentType
      })
    })
  }

  static updateLearnContentType(learnContentType) {
    if (typeof learnContentType._id === 'undefined') {
      return this.addLearnContentType(learnContentType)
    }

    return ApiHelper.fetch(`${API.URL + API.LEARN_CONTENT_TYPE}/${learnContentType['_id']}`, {
      method: 'PUT',
      body: JSON.stringify({
        learnContentType
      })
    })
  }

  static deleteLearnContentType(id) {
    return ApiHelper.fetch(`${API.URL + API.LEARN_CONTENT_TYPE}/${id}`, {
      method: 'DELETE'
    })
  }
}

export default LearnContentTypeService
